export default __webpack_public_path__ + "static/media/Hi-Rez-2021-RebrandedLOGO.8e7d2489.jpg";